var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashiconsYesAlt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 137,
    viewBox: "0 0 137 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 13.7C38.223 13.7 13.7 38.223 13.7 68.5C13.7 98.777 38.223 123.3 68.5 123.3C98.777 123.3 123.3 98.777 123.3 68.5C123.3 38.223 98.777 13.7 68.5 13.7ZM64.2872 100.421H55.1082L32.9142 69.322L42.1001 60.7595L59.6977 77.1995L94.9136 36.5722L104.093 43.0112L64.2872 100.421Z",
    fill: "#3775C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsYesAlt);
export default __webpack_public_path__ + "static/media/dashicons-yes-alt.ea53a102e103a881d998e0f5ba569b14.svg";
export { ForwardRef as ReactComponent };